import { createTheme } from '@mui/material/styles';

const neonTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#00F0FF' },
    secondary: { main: '#7C4DFF' },
    success: { main: '#00E676' },
    error: { main: '#FF1744' },
    warning: { main: '#FFC400' },
    background: { default: '#060B16', paper: 'transparent' },
    text: { primary: '#E8F6FF', secondary: '#8AA4BF' },
  },
  shape: { borderRadius: 16 },
  shadows: Array(25).fill('none'),
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: '1px solid rgb(120 154 181 / 43%)',
          boxShadow: '0 12px 24px -8px rgb(2, 72, 123), inset 0 0 40px rgba(2, 72, 123, 0.06)',
          backdropFilter: 'blur(10px)',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          height: 'auto',
          minHeight: 'unset',
        },
      },
    },
  },
});

export default neonTheme;
